import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import * as api from './api';

import { TarifsListStateData } from './types';

const initialState: TarifsListStateData = {
	data: { data: [], error: null },
	loading: false,
	error: '',
};

export const fetchTarifsList = createAsyncThunk('api/fetchTarifsList', (action: string) => api.fetchTarifsList(action));

const tarifsListSlice = createSlice({
	name: 'tarifsList',
	initialState,
	reducers: {},
	extraReducers(builder) {
		builder
			.addCase(fetchTarifsList.pending, (state) => {
				state.loading = true;
				state.error = '';
			})
			.addCase(fetchTarifsList.fulfilled, (state, action) => {
				state.loading = false;
				state.data = action.payload || {};
				state.error = '';
			})
			.addCase(fetchTarifsList.rejected, (state, action) => {
				state.loading = false;
				state.error = action.error.message || 'Ошибка загрузки данных';
			});
	},
});

export default tarifsListSlice.reducer;
